import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Textbox from 'components/Forms/Textbox';
import { toCamelCase } from 'utilities/utilities';
import './Inputs.scss';
import 'components/Forms/Checkbox.scss'

// wrappers for inputs wired to react-hook-form



function ErrorMessage({ hasError, errors, name, ID, isHidden, showAllErrors }) {

    const errorID = `${ID}Error`;

    return (
        showAllErrors ?

             (hasError ?
                Object.values(errors[name].types).map((value, index) => {
                    return (
                        <p className={`error-message ${isHidden ? 'mb-1' : 'mt-2 mb-3'}`} key={`${errorID}-${index}` }>
                       {value}
                    </p>
                    )
                })
                :
                <p className={`error-message ${isHidden ? 'mb-1' : 'mt-2 mb-3'}`}>
                </p>
                )
            :

            <p className={`error-message ${isHidden ? 'mb-1' : 'mt-2 mb-3'}`}>
                {hasError && errors[name].message}
            </p>          
    );

}

export function TextInput({
    name, label = 'Text label', register, errors, options, isDirty = false,
    type = 'text', placeholder, readonly = false, hideLabel = false, overlay,showAllErrors = false
}) {

    const hasError = errors && errors[name];
    const isHidden = type === 'hidden';
    const ID = toCamelCase(label);
    const errorID = `${ID}Error`;

    // layout won't work with Forms/FormGroup so we define our own
    // note that we assume all hidden fields should be marked as required
    // (hidden fields not needed to hold form data, only ever used when we need to show a label like date of birth)
    return (
        <Form.Group controlId={ID} className={`create-account-input ${hasError ? 'error-state' : ''}`}>
            <Row>
                <Col className="end-column"></Col>
                <Col className="middle-column px-3">
                    <Form.Label visuallyHidden={hideLabel}>
                        {label}
                        {options?.required || type === "hidden" ?
                            <><span className="required" aria-hidden="true"> *</span><span className="visually-hidden">Required</span></>
                            :
                            <></>
                        }
                    </Form.Label>
                </Col>
                <Col className="end-column"></Col>                                
            </Row>
            <Row>
                <Col className="end-column d-flex align-items-center justify-content-center">
                    {hasError && !isHidden && <i className="fas fa-exclamation-circle error-icon"></i>}
                    {!hasError && isDirty && !isHidden && <i className="fas fa-check-circle success-icon"></i>}
                </Col>
                <Col className={`middle-column px-3 ${overlay ? 'position-relative' : ''}`}>
                    <Textbox
                        type={type}
                        isSearch={false}
                        placeholder={placeholder}
                        readOnly={readonly}
                        {...register(name, options)}
                        aria-errormessage={errorID}
                        aria-invalid={hasError ? true : false}
                    />
                    {overlay &&
                        <div className="input-overlay">
                            {overlay}
                        </div>
                    }
                </Col>
                <Col className="end-column"></Col>
            </Row>
            <Row>
                <Col className="end-column"></Col>
                <Col className="middle-column px-3">
                    <div id={errorID}>
                        <ErrorMessage hasError={hasError} errors={errors} name={name} ID={ID} isHidden={isHidden} showAllErrors={showAllErrors}></ErrorMessage>
                    </div>
                </Col>
                <Col className="end-column"></Col>
            </Row>                       
        </Form.Group>
    );
}

export function CheckboxInput(
    { name, label = 'Check label', values, register, errors, options, type = 'checkbox', isDirty = false, hideLabel = false }
) {

    const hasError = errors && errors[name];
    const groupLabelID = toCamelCase(label);
    const errorID = `${groupLabelID}Error`;

    // layout won't work with Forms/FormCheckboxGroup so we define our own
    // we also will not be using Forms/Checkbox as we only need support for two states and radios
    return (
        <div className={`create-account-input ${hasError ? 'error-state' : ''}`}>
            <Row>
                <Col className="end-column"></Col>
                <Col className="middle-column px-3">
                    <Form.Label visuallyHidden={hideLabel} id={groupLabelID}>
                        {label}
                        {options?.required ?
                            <><span className="required" aria-hidden="true"> *</span><span className="visually-hidden">Required</span></>
                            :
                            <></>
                        }
                    </Form.Label>
                </Col>
                <Col className="end-column"></Col>
            </Row>
            <Row>
                <Col className="end-column d-flex align-items-center justify-content-center">
                    {hasError && <i className="fas fa-exclamation-circle error-icon"></i>}
                    {!hasError && isDirty && <i className="fas fa-check-circle success-icon"></i>}
                </Col>
                <Col className="middle-column px-3 pt-3" role="group"
                    aria-labelledby={groupLabelID} aria-describedby={errorID}>

                    {values.map((value, index) => (
                        <Form.Group key={`${name}${index}`} controlId={`${name}${index}`} className="d-inline-block me-4">
                            <Form.Control                        
                                type={type}
                                value={value.guid}
                                disabled={value.disabled}
                                className="ppm checkbox-md"
                                bsPrefix=" " // typically avoid using this but we need to remove .form-control
                                {...register(name, options)}
                            />
                            <Form.Label className="mb-3 ms-0">{value.name}</Form.Label>
                        </Form.Group>
                    ))}
                </Col>
                <Col className="end-column"></Col>
            </Row>
            <Row>
                <Col className="end-column"></Col>
                <Col className="middle-column px-3">
                    <p className="error-message mt-2 mb-3" id={errorID}>
                        {hasError && errors[name].message}
                    </p>
                </Col>
                <Col className="end-column"></Col>
            </Row>
        </div>
       
    );
} 